exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-account-editor{padding:20px}.user-account-editor .field.field.field{margin:0}.user-account-editor em{font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/UserAccountEditor/UserAccountEditor.scss
// module id = 878
// module chunks = 0